import moment from "moment";

export const dateShortString = (date) => {
	return moment(date).format("MMM D, YYYY");
};
